export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10500.5ababd20.jpg";